<template>
  <div>
    <!-- First page -->
    <el-table @sort-change="changeTableSort" :data="tableData" highlight-current-row border style="width: 100%; margin-top: 39px; margin-bottom: 20px" :empty-text="$t('general.empty_data')">
      <el-table-column sortable="custom" prop="employee_id" :label="$t('general.employee_id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_id }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empList.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column sortable="custom" prop="employee_type" :label="$t('empList.title')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.employee_type }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="500px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-document" @click="handleInsDeclaration(scope.$index, scope.row)">
            給与所得者の保険料控除申告</el-button>
          <el-button size="mini" type="success" icon="el-icon-user" @click="jump('/empList')">
            従業員情報変更</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleSortChange">
      </el-pagination>
    </div>
    <!-- 給与所得者の保険料控除申告メインページ -->
    <el-dialog title="給与所得者の保険料控除申告" :visible.sync="dialogInsDeclaration" width="94%" :before-close="handleClose">
      <div style="text-align:right; margin-top:20px;margin-bottom:20px; margin-right:50px;">
        <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="insAdd">
          給与所得者の保険料控除申告書作成
        </el-button>
      </div>
      <el-table v-loading="loading" :data="insDecAmountData" highlight-current-row border style="width: 100%;" :empty-text="$t('general.empty_data')">
        <el-table-column prop="year" label="年度" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.year }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="life_insurance_a" label="新生命保険料等の金額の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.life_insurance_a }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="life_insurance_b" label="旧生命保険料等の金額の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.life_insurance_b }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="care_insurance" label="介護医療保険料の金額の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.care_insurance }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="annuity_insurance_a" label="新個人年金保険料等の金額の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.annuity_insurance_a }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="annuity_insurance_b" label="旧個人年金保険料等の金額の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.annuity_insurance_b }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="earthquake_insurance" label="地震保険料の金額の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.earthquake_insurance }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="damage_insurance" label="旧長期損害保険料の金額の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.damage_insurance }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="social_insurance" label="社会保険料控除合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.social_insurance }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="c_deduction" label="小規模企業共済等掛金控除の合計額" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.c_deduction }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="330px">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="editInsDeclaration(scope.$index, scope.row)">
              {{ $t("general.edit") }}</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteInsDeclaration(scope.$index, scope.row)">
              {{ $t("general.delete") }}</el-button>
            <el-button size="mini" type="success" icon="el-icon-view" @click="printInsForm(scope.$index, scope.row)">保険料申告書</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogInsDeclaration = false" style="width: 120px">閉じる</el-button>
      </span>
    </el-dialog>
    <!-- 給与所得者の保険料控除申告書作成 -->
    <el-dialog title="給与所得者の保険料控除申告書作成" :visible.sync="dialogIns" width="94%" :before-close="handleDialogInsClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <el-row style=" text-align:left; font-weight:bold;">
          <el-col :span="4">
            <el-form-item prop="year">年度
              <el-select @change="yearChange" style="width:120px;margin-left:10px;" v-model="ruleForm.year" size="mini" :placeholder="$t('general.select')">
                <el-option v-for="item in year" :key="item.id" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-collapse v-model="activeNames" @change="handleChange">
          　<el-collapse-item title="保険料合計情報" name="1">
            　<el-row style="margin-left:50px; text-align:left;">
              　<el-col :span="6">
                <el-form-item label="新生命保険料等の金額の合計額" prop="life_insurance_a">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.life_insurance_a" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="旧生命保険料等の金額の合計額" prop="life_insurance_b">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.life_insurance_b" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="介護医療保険料の金額の合計額" prop="care_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.care_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="新個人年金保険料等の金額の合計額" prop="annuity_insurance_a">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.annuity_insurance_a" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="旧個人年金保険料等の金額の合計額" prop="annuity_insurance_b">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.annuity_insurance_b" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="地震保険料の金額の合計額" prop="earthquake_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.earthquake_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="6">
                <el-form-item label="旧長期損害保険料の金額の合計額" prop="damage_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.damage_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="6">
                <el-form-item label="社会保険料控除合計額" prop="social_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.social_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="6">
                <el-form-item label="小規模企業共済等掛金控除の合計額" prop="c_deduction">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.c_deduction" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>
          　</el-collapse>
        <div style="text-align:right;margin-bottom:30px;margin-top:30px;">
          <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="insFormAdd">給与所得者の保険料項目詳細追加</el-button>
        </div>
        　<el-table :data="insDecItemData" highlight-current-row border style="width: 100%;" :empty-text="$t('general.empty_data')">
          <el-table-column prop="ins_type" label="保険料の種類" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_type }}</span>
            </template>　　　　　
          </el-table-column>

          <el-table-column prop="ins_c_name" label="保険会社等・保険料支払先の名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_c_name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_type_detail" label="保険等の種類" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_type_detail }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_date" label="保険期間又は年金支払期間" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_date }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_apply_name" label="保険等契約者・負担者氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_apply_name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_recevie_name" label="受取者氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_recevie_name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_relation" label="あなたと続柄" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_relation }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="district" label="区分" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.district }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="district" label="支払った金額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_payment }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="confirm" label="給与の支払者の確認" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.confirm }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="220px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="insDetailEdit(scope.$index, scope.row)">
                編集</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteInsDecItem(scope.$index, scope.row)">
                削除</el-button>
            </template>
          </el-table-column>
          　　　
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="close_comfirm()" style="width: 120px">閉じる</el-button>
        <el-button type="primary" @click="saveInsDecAmount()" style="width: 120px">保存</el-button>
        <el-button type="success" @click="calInsDecAmount()" style="width: 120px">プレビュー</el-button>
      </span>
    </el-dialog>
    <!-- 給与所得者の保険料項目詳細追加 -->
    <el-dialog :visible.sync="dialogInsDetail" width="72%" :before-close="handleClose">
      <span slot="title" style="font-size:18px;">{{ruleForm.year}}&nbsp;&nbsp;給与所得者の保険料項目詳細追加</span>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <el-row style=" text-align:left; font-weight:bold;">
          <el-col :span="8">
            <el-form-item prop="ins_type">保険料の種類
              <el-select style="width:180px;margin-left:10px;" v-model="ruleForm.ins_type" size="mini" :placeholder="$t('general.select')">
                <el-option v-for="item in ins_type" :key="item.id" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        　<el-collapse v-model="activeNames" @change="handleChange">
          　<el-collapse-item title="生命保険料控除" name="1" v-if="ruleForm.ins_type === '一般の生命保険料' || ruleForm.ins_type === '介護医療保険料' || ruleForm.ins_type === '個人年金保険料'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">
                <el-form-item label="保険会社等の名称" prop="ins_c_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の種類" prop="ins_type_detail">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険期間又は年金支払期間" prop="ins_date">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_date" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の契約者の氏名" prop="ins_apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="16">
                <el-form-item label="保険金等の受取人">
                  <br>
                  氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_recevie_name" size="mini" style="width: 225px;"></el-input>
                  <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8" v-if="ruleForm.ins_type !='介護医療保険料'">
                <el-form-item label="新・旧保険料の区分" prop="district">
                  <br>
                  <el-radio-group v-model="ruleForm.district" style="margin-left: 0px">
                    <el-radio label="新">新</el-radio>
                    <el-radio label="旧" style="margin-left:150px;">旧</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              　<el-col :span="8">
                <el-form-item label="あなたが本年中に支払った保険料等の金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="8">
                <el-form-item label="給与の支払者の確認" prop="confirm">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.confirm" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>
              　<el-col :span="24" v-if="ruleForm.ins_type ==='個人年金保険料'">
                <el-form-item label="年金支払開始日">
                  <br>
                  <el-select style="width:75px;" v-model="ruleForm.era" size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in era" :key="item.id" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <el-input v-model="ruleForm.payYear" size="mini" style="width: 45px;"></el-input>
                  年
                  <el-input v-model="ruleForm.payMonth" size="mini" style="width: 45px;"></el-input>
                  月
                  <el-input v-model="ruleForm.payDay" size="mini" style="width: 45px;"></el-input>
                  日
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>

          　<el-collapse-item title="地震保険料控除" name="2" v-if="ruleForm.ins_type === '地震保険料'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">
                <el-form-item label="保険会社等の名称" prop="ins_c_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の種類（目的）" prop="ins_type_detail">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険期間" prop="ins_date">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_date" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の契約者の氏名" prop="ins_apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="16">
                <el-form-item label="保険等の対象となった家屋等に居住又は家財を利用している者等">
                  <br>
                  氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_recevie_name" size="mini" style="width: 225px;"></el-input>
                  <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="地震保険料又は旧長期損害保険料区分" prop="district">
                  <el-radio-group v-model="ruleForm.district" style="margin-left: 0px">
                    <el-radio label="地震">地震</el-radio>
                    <el-radio label="旧長期" style="margin-left:110px;">旧長期</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              　<el-col :span="16">
                <el-form-item label="あなたが本年中に支払った保険等のうち、左欄の区分に係る金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="8">
                <el-form-item label="給与の支払者の確認" prop="confirm">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.confirm" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>

          　<el-collapse-item title="社会保険料控除" name="3" v-if="ruleForm.ins_type === '社会保険料'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">
                <el-form-item label="社会保険の種類" prop="ins_type_detail">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険料支払先の名称" prop="ins_c_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="あなたが本年中に支払った保険料の金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="16">
                <el-form-item label="保険料を負担することになっている人">
                  <br>
                  氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 225px;"></el-input>
                  <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>

          　<el-collapse-item title="小規模企業共済等掛金控除" name="4" v-if="ruleForm.ins_type === '小規模企業共済等掛金'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="12">
                <el-form-item label="種類" prop="ins_type_detail">
                  <el-select style="width:350px;" v-model="ruleForm.ins_type_detail" size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in ins_type_detail" :key="item.id" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              　<el-col :span="12">
                <el-form-item label="あなたが本年中に支払った掛金の金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 170px;"></el-input>
                  円
                </el-form-item>
              </el-col>

            </el-row>
            　</el-collapse-item>
          　</el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addInsDecItem()" style="width: 120px">保存</el-button>
        <el-button @click="cancelInsDetail">キャンセル</el-button>
      </span>
    </el-dialog>
    <!-- 給与所得者の保険料控除項目詳細編集 -->
    <el-dialog :visible.sync="dialogInsDetailEdit" width="72%" :before-close="handleClose">
      <span slot="title" style="font-size:18px;">{{ruleForm.year}}&nbsp;&nbsp;給与所得者の保険料控除項目詳細編集</span>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <el-row style=" text-align:left; font-weight:bold;">
          <el-col :span="8">
            <el-form-item prop="ins_type">保険料の種類
              <el-input style="width:180px;margin-left:10px;" v-model="ruleForm.ins_type" size="mini" readonly="readonly">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        　<el-collapse v-model="activeNames" @change="handleChange">
          　<el-collapse-item title="生命保険料控除" name="1" v-if="ruleForm.ins_type === '一般の生命保険料' || ruleForm.ins_type === '介護医療保険料' || ruleForm.ins_type === '個人年金保険料'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">
                <el-form-item label="保険会社等の名称" prop="ins_c_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の種類" prop="ins_type_detail">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険期間又は年金支払期間" prop="ins_date">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_date" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の契約者の氏名" prop="ins_apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="16">
                <el-form-item label="保険金等の受取人">
                  <br>
                  氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_recevie_name" size="mini" style="width: 225px;"></el-input>
                  <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8" v-if="ruleForm.ins_type !='介護医療保険料'">
                <el-form-item label="新・旧保険料の区分" prop="district">
                  <br>
                  <el-radio-group v-model="ruleForm.district" style="margin-left: 0px">
                    <el-radio label="新">新</el-radio>
                    <el-radio label="旧" style="margin-left:150px;">旧</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              　<el-col :span="8">
                <el-form-item label="あなたが本年中に支払った保険料等の金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="8">
                <el-form-item label="給与の支払者の確認" prop="confirm">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.confirm" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>
              　<el-col :span="24" v-if="ruleForm.ins_type ==='個人年金保険料'">
                <el-form-item label="年金支払開始日" prop="pay_date">
                  <br>
                  <el-select style="width:75px;" v-model="ruleForm.era" size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in era" :key="item.id" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <el-input v-model="ruleForm.payYear" size="mini" style="width: 45px;"></el-input>
                  年
                  <el-input v-model="ruleForm.payMonth" size="mini" style="width: 45px;"></el-input>
                  月
                  <el-input v-model="ruleForm.payDay" size="mini" style="width: 45px;"></el-input>
                  日
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>

          　<el-collapse-item title="地震保険料控除" name="2" v-if="ruleForm.ins_type === '地震保険料'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">
                <el-form-item label="保険会社等の名称" prop="ins_c_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の種類（目的）" prop="ins_type_detail">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険期間" prop="ins_date">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_date" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険等の契約者の氏名" prop="ins_apply_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="16">
                <el-form-item label="保険等の対象となった家屋等に居住又は家財を利用している者等">
                  <br>
                  氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_recevie_name" size="mini" style="width: 225px;"></el-input>
                  <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="地震保険料又は旧長期損害保険料区分" prop="district">
                  <el-radio-group v-model="ruleForm.district" style="margin-left: 0px">
                    <el-radio label="地震">地震</el-radio>
                    <el-radio label="旧長期" style="margin-left:110px;">旧長期</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              　<el-col :span="16">
                <el-form-item label="あなたが本年中に支払った保険等のうち、左欄の区分に係る金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="8">
                <el-form-item label="給与の支払者の確認" prop="confirm">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.confirm" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>

          　<el-collapse-item title="社会保険料控除" name="3" v-if="ruleForm.ins_type === '社会保険料'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="8">
                <el-form-item label="社会保険の種類" prop="ins_type_detail">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_type_detail" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="保険料支払先の名称" prop="ins_c_name">
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_c_name" size="mini" style="width: 260px;"></el-input>
                </el-form-item>
              </el-col>

              　<el-col :span="8">
                <el-form-item label="あなたが本年中に支払った保険料の金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 260px;"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="16">
                <el-form-item label="保険料を負担することになっている人">
                  <br>
                  氏名&nbsp;&nbsp;<el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_apply_name" size="mini" style="width: 225px;"></el-input>
                  <span style="margin-left:58px;">あなたとの続柄</span>&nbsp;&nbsp;
                  <el-input prefix-icon="el-icon-edit" v-model="ruleForm.ins_relation" size="mini" style="width: 155px;"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>

          　<el-collapse-item title="小規模企業共済等掛金控除" name="4" v-if="ruleForm.ins_type === '小規模企業共済等掛金'">
            　<el-row style="margin-left:50px; text-align:left; margin-right:20px;">
              　<el-col :span="12">
                <el-form-item label="種類" prop="ins_type_detail">
                  <el-select style="width:350px;" v-model="ruleForm.ins_type_detail" size="mini" :placeholder="$t('general.select')">
                    <el-option v-for="item in ins_type_detail" :key="item.id" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              　<el-col :span="12">
                <el-form-item label="あなたが本年中に支払った掛金の金額" prop="ins_payment">
                  <el-input @change="paymentToMoney()" prefix-icon="el-icon-edit" v-model="ruleForm.ins_payment" size="mini" style="width: 170px;"></el-input>
                  円
                </el-form-item>
              </el-col>

            </el-row>
            　</el-collapse-item>
          　</el-collapse>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateInsDecItem" style="width: 120px">保存</el-button>
        <el-button @click="cancelInsDetail">キャンセル</el-button>
      </span>
    </el-dialog>
    <!-- 給与所得者の保険料控除申告書編集 -->
    <el-dialog :visible.sync="dialogInsEdit" width="94%" :before-close="handleDialogInsClose">
      <span slot="title" style="font-size:18px;">{{ruleForm.year}}&nbsp;&nbsp;給与所得者の保険料控除申告書編集</span>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-form" :label-position="labelPosition">
        <el-collapse v-model="activeNames" @change="handleChange">
          　<el-collapse-item title="保険料合計情報" name="1">
            　<el-row style="margin-left:50px; text-align:left;">
              　<el-col :span="6">
                <el-form-item label="新生命保険料等の金額の合計額" prop="life_insurance_a">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.life_insurance_a" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="旧生命保険料等の金額の合計額" prop="life_insurance_b">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.life_insurance_b" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="介護医療保険料の金額の合計額" prop="care_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.care_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="新個人年金保険料等の金額の合計額" prop="annuity_insurance_a">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.annuity_insurance_a" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="旧個人年金保険料等の金額の合計額" prop="annuity_insurance_b">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.annuity_insurance_b" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>

              　<el-col :span="6">
                <el-form-item label="地震保険料の金額の合計額" prop="earthquake_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.earthquake_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="6">
                <el-form-item label="旧長期損害保険料の金額の合計額" prop="damage_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.damage_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="6">
                <el-form-item label="社会保険料控除合計額" prop="social_insurance">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.social_insurance" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
              　<el-col :span="6">
                <el-form-item label="小規模企業共済等掛金控除の合計額" prop="c_deduction">
                  <el-input prefix-icon="el-icon-info" v-model="insForm.c_deduction" size="mini" style="width: 210px;" readonly="readonly"></el-input>
                  円
                </el-form-item>
              </el-col>
            </el-row>
            　</el-collapse-item>
          　</el-collapse>
        <div style="text-align:right;margin-bottom:30px;margin-top:30px;">
          <el-button class="el-icon-circle-plus-outline" type="primary" size="mini" @click="insFormAdd()">給与所得者の保険料項目詳細追加</el-button>
        </div>
        　<el-table :data="insDecItemData" highlight-current-row border style="width: 100%;" :empty-text="$t('general.empty_data')">
          <el-table-column prop="ins_type" label="保険料の種類" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_type }}</span>
            </template>　　　　　
          </el-table-column>

          <el-table-column prop="ins_c_name" label="保険会社等・保険料支払先の名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_c_name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_type_detail" label="保険等の種類" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_type_detail }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_date" label="保険期間又は年金支払期間" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_date }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_apply_name" label="保険等契約者・負担者氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_apply_name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_recevie_name" label="受取者氏名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_recevie_name }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="ins_relation" label="あなたと続柄" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_relation }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="district" label="区分" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.district }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="district" label="支払った金額" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.ins_payment }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="confirm" label="給与の支払者の確認" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.confirm }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="220px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="insDetailEdit(scope.$index, scope.row)">
                編集</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteInsDecItem(scope.$index, scope.row)">
                削除</el-button>
            </template>
          </el-table-column>
          　　　
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="close_comfirm()" style="width: 120px">閉じる</el-button>
        <el-button type="primary" @click="saveInsDecAmount()" style="width: 120px">保存</el-button>
        <el-button type="success" @click="calInsDecAmount()" style="width: 120px">プレビュー</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      dialogIns: false,
      dialogInsDetail: false,
      dialogInsDeclaration: false,
      dialogInsDetailEdit: false,
      dialogInsEdit: false,
      dialogCloseComfirm: false,
      activeNames: ['1', '2', '3', '4'],
      tableData: [],
      insDecAmountData: [],
      insDecItemData: [],
      ruleForm: {
        year: "",
        era: "",
        ins_type: "一般の生命保険料",
        ins_c_name: "",
        ins_type_detail: "",
        ins_date: "",
        ins_apply_name: "",
        ins_recevie_name: "",
        ins_relation: "",
        district: "",
        ins_payment: 0,
        confirm: "",
        payYear: "",
        payMonth: "",
        payDay: "",
      },
      insForm: {
        life_insurance_a: 0,
        life_insurance_b: 0,
        care_insurance: 0,
        annuity_insurance_a: 0,
        annuity_insurance_b: 0,
        earthquake_insurance: 0,
        damage_insurance: 0,
        social_insurance: 0,
        ins_relation: 0,
        district: 0,
        c_deduction: 0
      },
      //年度
      year: [
        {
          label: "令和2年分",
          value: "令和2年分",
        },
        {
          label: "令和3年分",
          value: "令和3年分",
        }
      ],
      //保険等の種類      
      ins_type: [
        {
          label: "一般の生命保険料",
          value: "一般の生命保険料",
        },
        {
          label: "介護医療保険料",
          value: "介護医療保険料",
        },
        {
          label: "個人年金保険料",
          value: "個人年金保険料",
        },
        {
          label: "地震保険料",
          value: "地震保険料",
        },
        {
          label: "社会保険料",
          value: "社会保険料",
        },
        {
          label: "小規模企業共済等掛金",
          value: "小規模企業共済等掛金",
        },
      ],
      //区分     
      district: [
        {
          label: "新",
          value: "新",
        },
        {
          label: "旧",
          value: "旧",
        }
      ],
      //元号
      era: [
        {
          label: "明治",
          value: "M",
        },
        {
          label: "大正",
          value: "T",
        },
        {
          label: "昭和",
          value: "S",
        },
        {
          label: "平成",
          value: "H",
        },
        {
          label: "令和",
          value: "R",
        },
      ],
      //保険種類詳細      
      ins_type_detail: [
        {
          label: "独立行政法人中小企業基盤整備機構の共済契約の掛金",
          value: "独立行政法人中小企業基盤整備機構の共済契約の掛金",
        },
        {
          label: "確定拠出年金法に規定する企業型年金加入者掛金",
          value: "確定拠出年金法に規定する企業型年金加入者掛金",
        },
        {
          label: "確定拠出年金法に規定する個人型年金加入者掛金",
          value: "確定拠出年金法に規定する個人型年金加入者掛金",
        },
        {
          label: "心身障害者扶養共済制度に関する契約の掛金",
          value: "心身障害者扶養共済制度に関する契約の掛金",
        }
      ],
      //一ページデータの数 
      pageSize: 6,
      //首页分页
      currentPage: 1,
      //统计员工总数
      total: 0,
      //ソート順番
      sortName: "",
      sortOrder: "",
      eid: "",
      tempForm: {},
      name: "",
      employee_id: ""
    };
  },
  methods: {
    jump(path) {
      this.$router.push(path);
    },
    preview(index, row, code) {
      var uid = window.localStorage.getItem('LoginUserId');
      var name = this.name;
      window.open("/pdf/給与所得者の保険料控除申告書-" + row.year + name + "no." + uid + code + ".pdf");
    },
    //給与所得者の保険料控除申告書作成・編集閉じる
    close_comfirm() {
      if (this.isInsDecValueEqual(this.tempForm, this.insForm) === false && Object.keys(this.tempForm) != "") {
        this.$confirm("変更内容を保存してください。", this.$t("general.hint"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: "OK",
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then(() => {
            this.saveInsDecAmount();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "キャンセルしました。",
            });
          });
      } else {
        this.close();
      }
    },
    //合計額変更チェック    
    isInsDecValueEqual(a, b) {
      var aProps = Object.keys(a);
      var bProps = Object.keys(b);
      if (aProps.length != bProps.length) {
        return false;
      }
      for (var i = 0; i < aProps.length; i++) {
        var key = aProps[i];
        var valueA = a[key];
        var valueB = b[key];
        if (valueA !== valueB && valueA != undefined && valueB != undefined) {
          return false;
        }
      }
      return true;
    },
    //給与所得者の保険料控除申告页面的删除按钮
    deleteInsDeclaration(index, row) {
      this.$confirm("本当に削除しますか？保険料控除の詳細情報も削除するのでご注意ください。", this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
            eid: row.eid,
            year: row.year
          });
          this.axios({
            method: "post",
            url: "/deleteInsDec",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result === "success") {
                this.ListInsDeclarationByEid();
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
              } else if (result === "itemFalse") {
                this.$message({
                  type: "warning",
                  message: "保険料詳細を削除する際にエラーが発生しました。"
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "エラーが発生しました。"
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "キャンセルしました",
          });
        });
    },
    //給与所得者の保険料控除申告页面的编辑按钮
    editInsDeclaration(index, row) {
      this.dialogInsEdit = true;
      this.insForm = Object.assign({}, row);
      this.ruleForm.year = row.year;
      let postData = this.qs.stringify({
        eid: this.eid,
        year: this.ruleForm.year,
      });
      this.axios({
        method: "post",
        url: "/selectInsDecItem",
        data: postData,
      })
        .then((response) => {
          for (var j = 0; j < response.data.length; j++) {
            response.data[j].ins_payment = Number(response.data[j].ins_payment).toLocaleString();
          }
          this.insDecItemData = response.data;
          //在查询出当年的保险料详细信息后，进行合计计算。
          this.calInsDecAmount();
          //计算完成显示时要转成Money格式。
          this.insFormToMoney();
          //将当前insForm赋值给tempForm，用来判断关闭页面时候insForm值是否有变化。
          //如果有变化，需要对当前insForm的值保存到数据库中
          this.tempForm = this.insForm;
        })
        .catch((error) => {
        })
    },
    //选择年度，詳細一覧検索
    yearChange() {
      let postData = this.qs.stringify({
        eid: this.eid,
        year: this.ruleForm.year,
      });
      this.axios({
        method: "post",
        url: "/selectInsDecItem",
        data: postData,
      })
        .then((response) => {
          for (var j = 0; j < response.data.length; j++) {
            response.data[j].ins_payment = Number(response.data[j].ins_payment).toLocaleString();
          }
          this.insDecItemData = response.data;
          //在查询出当年的保险料详细信息后，进行合计计算。
          this.calInsDecAmount();
          this.insFormToMoney();
          this.tempForm = this.insForm;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //給与所得者の保険料控除申告書プレビュー
    printInsForm(index, row) {
      this.loading = true;
      let postData = this.qs.stringify({
        id: row.id,
        year: row.year,
        employee_id: this.employee_id,
        eid: this.eid
      });
      this.axios({
        method: "post",
        url: "/printInsDeclaration",
        data: postData,
      })
        .then((response) => {
          if (response.data.status === "success") {
            this.$message({
              type: "success",
              message: this.$t("general.print_completed"),
            });
            var code = response.data.msg;
            setTimeout(() => { this.preview(index, row, code); }, 700);
            this.loading = false;
          } else {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: this.$t("general.print_failed"),
          });
          this.loading = false;
          console.log(error);
        });
    },
    //计算各种保险料的合计额
    //计算前需要对table表格中的ins_payment全部去掉逗号，转成数字格式。
    calInsDecAmount() {
      this.emptyInsDecData();
      for (var i = 0; i < this.insDecItemData.length; i++) {
        var payment = Number(this.insDecItemData[i].ins_payment.split(",").join(""));
        switch (this.insDecItemData[i].ins_type) {
          case '一般の生命保険料':
            if (this.insDecItemData[i].district === "新") {
              this.insForm.life_insurance_a = Number(this.insForm.life_insurance_a) + payment;
            } else if (this.insDecItemData[i].district === "旧") {
              this.insForm.life_insurance_b = Number(this.insForm.life_insurance_b) + payment;
            }
            break;
          case '介護医療保険料':
            this.insForm.care_insurance = Number(this.insForm.care_insurance) + payment;
            break;
          case '個人年金保険料':
            if (this.insDecItemData[i].district === "新") {
              this.insForm.annuity_insurance_a = Number(this.insForm.annuity_insurance_a) + payment;
            } else if (this.insDecItemData[i].district === "旧") {
              this.insForm.annuity_insurance_b = Number(this.insForm.annuity_insurance_b) + payment;
            }
            break;
          case '地震保険料':
            if (this.insDecItemData[i].district === "地震") {
              this.insForm.earthquake_insurance = Number(this.insForm.earthquake_insurance) + payment;
            } else if (this.insDecItemData[i].district === "旧長期") {
              this.insForm.damage_insurance = Number(this.insForm.damage_insurance) + payment;
            }
            break;
          case '社会保険料':
            this.insForm.social_insurance = Number(this.insForm.social_insurance) + payment;
            break;
          case '小規模企業共済等掛金':
            this.insForm.c_deduction = Number(this.insForm.c_deduction) + payment;
            break;
        }
      }

    },
    insFormToMoney() {
      this.insForm.life_insurance_a = this.insForm.life_insurance_a.toLocaleString();
      this.insForm.life_insurance_b = this.insForm.life_insurance_b.toLocaleString();
      this.insForm.care_insurance = this.insForm.care_insurance.toLocaleString();
      this.insForm.annuity_insurance_a = this.insForm.annuity_insurance_a.toLocaleString();
      this.insForm.annuity_insurance_b = this.insForm.annuity_insurance_b.toLocaleString();
      this.insForm.earthquake_insurance = this.insForm.earthquake_insurance.toLocaleString();
      this.insForm.damage_insurance = this.insForm.damage_insurance.toLocaleString();
      this.insForm.social_insurance = this.insForm.social_insurance.toLocaleString();
      this.insForm.c_deduction = this.insForm.c_deduction.toLocaleString();
    },
    insFormToNumString() {
      this.insForm.life_insurance_a = String(this.insForm.life_insurance_a);
      this.insForm.life_insurance_b = String(this.insForm.life_insurance_b);
      this.insForm.care_insurance = String(this.insForm.care_insurance);
      this.insForm.annuity_insurance_a = String(this.insForm.annuity_insurance_a);
      this.insForm.annuity_insurance_b = String(this.insForm.annuity_insurance_b);
      this.insForm.earthquake_insurance = String(this.insForm.earthquake_insurance);
      this.insForm.damage_insurance = String(this.insForm.damage_insurance);
      this.insForm.social_insurance = String(this.insForm.social_insurance);
      this.insForm.c_deduction = String(this.insForm.c_deduction);
    },
    insFormToNum() {
      this.insFormToNumString();
      this.insForm.life_insurance_a = Number(this.insForm.life_insurance_a.split(",").join(""));
      this.insForm.life_insurance_b = Number(this.insForm.life_insurance_b.split(",").join(""));
      this.insForm.care_insurance = Number(this.insForm.care_insurance.split(",").join(""));
      this.insForm.annuity_insurance_a = Number(this.insForm.annuity_insurance_a.split(",").join(""));
      this.insForm.annuity_insurance_b = Number(this.insForm.annuity_insurance_b.split(",").join(""));
      this.insForm.earthquake_insurance = Number(this.insForm.earthquake_insurance.split(",").join(""));
      this.insForm.damage_insurance = Number(this.insForm.damage_insurance.split(",").join(""));
      this.insForm.social_insurance = Number(this.insForm.social_insurance.split(",").join(""));
      this.insForm.c_deduction = Number(this.insForm.c_deduction.split(",").join(""));
    },
    //給与所得者の保険料控除申告書作成页面保存按钮
    //保存insForm数据前，先转成数字格式，去掉逗号，
    saveInsDecAmount() {
      this.insFormToNum();
      let postData = this.qs.stringify({
        eid: this.eid,
        year: this.ruleForm.year,
        life_insurance_a: this.insForm.life_insurance_a,
        life_insurance_b: this.insForm.life_insurance_b,
        care_insurance: this.insForm.care_insurance,
        annuity_insurance_a: this.insForm.annuity_insurance_a,
        annuity_insurance_b: this.insForm.annuity_insurance_b,
        earthquake_insurance: this.insForm.earthquake_insurance,
        damage_insurance: this.insForm.damage_insurance,
        social_insurance: this.insForm.social_insurance,
        c_deduction: this.insForm.c_deduction
      });
      this.axios({
        method: "post",
        url: "/saveInsDecAmount",
        data: postData,
      })
        .then((response) => {
          var result = response.data;
          if (result === "update" || result === "insert") {
            this.$message({
              type: "success",
              message: "保存しました"
            });
            this.tempForm = {};
            this.ListInsDeclarationByEid();
            this.close();
          } else {
            this.$message({
              type: "error",
              message: "エラーが発生しました"
            });
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: "エラーが発生しました"
          });
        });
    },
    //保険料詳細項目削除
    deleteInsDecItem(index, row) {
      this.$confirm(this.$t("general.sure_delete"), this.$t("general.hint"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: "OK",
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then(() => {
          let postData = this.qs.stringify({
            id: row.id,
          });
          this.axios({
            method: "post",
            url: "/deleteInsDecItem",
            data: postData,
          })
            .then((response) => {
              var result = response.data;
              if (result != 0) {
                this.InsDecItemList();
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "エラーが発生しました",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "キャンセルしました",
          });
        });
    },
    //保険料詳細編集
    updateInsDecItem() {
      //判断所选项目是否已经超出上限。比如一般生命保险最多追加四条数据。
      if (this.insDecItemConfirm() === 0) {
        return "";
      }
      this.ruleForm.ins_payment = Number(this.ruleForm.ins_payment.split(",").join(""));
      let postData = this.qs.stringify({
        id: this.ruleForm.id,
        eid: this.eid,
        year: this.ruleForm.year,
        ins_type: this.ruleForm.ins_type,
        ins_c_name: this.ruleForm.ins_c_name,
        ins_type_detail: this.ruleForm.ins_type_detail,
        ins_date: this.ruleForm.ins_date,
        ins_apply_name: this.ruleForm.ins_apply_name,
        ins_recevie_name: this.ruleForm.ins_recevie_name,
        ins_relation: this.ruleForm.ins_relation,
        district: this.ruleForm.district,
        ins_payment: this.ruleForm.ins_payment,
        confirm: this.ruleForm.confirm,
        pay_date: this.ruleForm.era + "-" + this.ruleForm.payYear + "-" + this.ruleForm.payMonth + "-" + this.ruleForm.payDay
      });
      this.axios({
        method: "post",
        url: "/updateInsDecItem",
        data: postData,
      })
        .then((response) => {
          var result = response.data;
          if (result != 0) {
            this.InsDecItemList();
            this.$message({
              type: "success",
              message: "更新しました"
            });
            this.emptyInsDecItemData();
            this.dialogInsDetailEdit = false;
          } else {
            this.$message({
              type: "warning",
              message: "エラーが発生しました"
            });
          }
        })
        .catch((error) => {
          this.$message({
            type: "warning",
            message: "エラーが発生しました"
          });
        });
    },
    //保険料詳細新規
    addInsDecItem() {
      if (this.insDecItemConfirm() === 0) {
        return "";
      }
      this.ruleForm.ins_payment = Number(this.ruleForm.ins_payment.split(",").join(""));
      if (this.ruleForm.year != "") {
        let postData = this.qs.stringify({
          eid: this.eid,
          year: this.ruleForm.year,
          ins_type: this.ruleForm.ins_type,
          ins_c_name: this.ruleForm.ins_c_name,
          ins_type_detail: this.ruleForm.ins_type_detail,
          ins_date: this.ruleForm.ins_date,
          ins_apply_name: this.ruleForm.ins_apply_name,
          ins_recevie_name: this.ruleForm.ins_recevie_name,
          ins_relation: this.ruleForm.ins_relation,
          district: this.ruleForm.district,
          ins_payment: this.ruleForm.ins_payment,
          confirm: this.ruleForm.confirm,
          pay_date: this.ruleForm.era + "-" + this.ruleForm.payYear + "-" + this.ruleForm.payMonth + "-" + this.ruleForm.payDay
        });
        this.axios({
          method: "post",
          url: "/insertInsDecItem",
          data: postData,
        })
          .then((response) => {
            var result = response.data;
            if (result != 0) {
              this.InsDecItemList();
              this.$message({
                type: "success",
                message: "新規しました。"
              });
              this.dialogInsDetail = false;
              this.emptyInsDecItemData();
            } else {
              this.$message({
                type: "error",
                message: "エラーが発生しました"
              });
            }
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: "エラーが発生しました"
            });
          });
      }
    },
    //ins_payment转Money格式
    paymentToMoney() {
      this.ruleForm.ins_payment = Number(this.ruleForm.ins_payment).toLocaleString();
    },
    //要判断追加新的item项目时候，是否超出限制。如，一般生命保险最多追加四条。
    //InsDecItemList方法赋值的insDecItemData用来与当前追加的item项目比对。判断是否允许追加该项目。
    insDecItemConfirm() {
      var insItem1 = 0;
      var insItem2 = 0;
      var insItem3 = 0;
      var insItem4 = 0;
      var insItem5 = 0;
      var insItem6_1 = 0;
      var insItem6_2 = 0;
      var insItem6_3 = 0;
      var insItem6_4 = 0;
      //统计当前insDecItem包含的项目数。
      for (var i = 0; i < this.insDecItemData.length; i++) {
        switch (this.insDecItemData[i].ins_type) {
          case '一般の生命保険料':
            insItem1++;
            break;
          case '介護医療保険料':
            insItem2++;
            break;
          case '個人年金保険料':
            insItem3++;
            break;
          case '地震保険料':
            insItem4++;
            break;
          case '社会保険料':
            insItem5++;
            break;
          case '小規模企業共済等掛金':
            switch (this.insDecItemData[i].ins_type_detail) {
              case '独立行政法人中小企業基盤整備機構の共済契約の掛金':
                insItem6_1++;
                break;
              case '確定拠出年金法に規定する企業型年金加入者掛金':
                insItem6_2++;
                break;
              case '確定拠出年金法に規定する個人型年金加入者掛金':
                insItem6_3++;
                break;
              case '心身障害者扶養共済制度に関する契約の掛金':
                insItem6_4++;
                break;
            }
            break;
        }
      }
      //判断当前追加的项目是否已经达到上限。达到上限则不能追加做成。
      if (insItem1 === 4 && this.ruleForm.ins_type === "一般の生命保険料") {
        this.$message({
          type: "error",
          message: "一般の生命保険料の追加上限は4です。"
        });
        return 0;
      } else if (insItem2 === 3 && this.ruleForm.ins_type === "介護医療保険料") {
        this.$message({
          type: "error",
          message: "介護医療保険料の追加上限は3です。"
        });
        return 0;
      } else if (insItem3 === 3 && this.ruleForm.ins_type === "個人年金保険料") {
        this.$message({
          type: "error",
          message: "個人年金保険料の追加上限は3です。"
        });
        return 0;
      } else if (insItem4 === 2 && this.ruleForm.ins_type === "地震保険料") {
        this.$message({
          type: "error",
          message: "地震保険料の追加上限は2です。"
        });
        return 0;
      } else if (insItem5 === 2 && this.ruleForm.ins_type === "社会保険料") {
        this.$message({
          type: "error",
          message: "社会保険料の追加上限は2です。"
        });
        return 0;
      } else if (insItem6_1 === 1 && this.ruleForm.ins_type_detail === "独立行政法人中小企業基盤整備機構の共済契約の掛金") {
        this.$message({
          type: "error",
          message: "独立行政法人中小企業基盤整備機構の共済契約の掛金の追加上限は一つです。"
        });
        return 0;
      } else if (insItem6_2 === 1 && this.ruleForm.ins_type_detail === "確定拠出年金法に規定する企業型年金加入者掛金") {
        this.$message({
          type: "error",
          message: "確定拠出年金法に規定する企業型年金加入者掛金の追加上限は一つです。"
        });
        return 0;
      } else if (insItem6_3 === 1 && this.ins_type_detail === "確定拠出年金法に規定する個人型年金加入者掛金") {
        this.$message({
          type: "error",
          message: "確定拠出年金法に規定する個人型年金加入者掛金の追加上限は一つです。"
        });
        return 0;
      } else if (insItem6_4 === 1 && this.ins_type_detail === "心身障害者扶養共済制度に関する契約の掛金") {
        this.$message({
          type: "error",
          message: "心身障害者扶養共済制度に関する契約の掛金の追加上限は一つです。"
        });
        return 0;
      }
    },
    //保険料詳細情報一覧
    //返回值需要变为金额的显示方法，加逗号
    InsDecItemList() {
      let postData = this.qs.stringify({
        eid: this.eid,
        year: this.ruleForm.year,
      });
      this.axios({
        method: "post",
        url: "/selectInsDecItem",
        data: postData,
      })
        .then((response) => {
          for (var j = 0; j < response.data.length; j++) {
            response.data[j].ins_payment = Number(response.data[j].ins_payment).toLocaleString();
          }
          this.insDecItemData = response.data;

          //在查询出当年的保险料详细信息后，进行合计计算。
          this.calInsDecAmount();
          this.insFormToMoney();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //詳細編集
    insDetailEdit(index, row) {
      this.dialogInsDetailEdit = true;
      this.ruleForm = Object.assign({}, this.ruleForm, row);
      this.ruleForm.pay_date = row.pay_date;
      if (this.ruleForm.pay_date != "") {
        var payDateStr = this.ruleForm.pay_date;
        var payDateArr = payDateStr.split("-");
        this.ruleForm.era = payDateArr[0];
        this.ruleForm.payYear = payDateArr[1];
        this.ruleForm.payMonth = payDateArr[2];
        this.ruleForm.payDay = payDateArr[3];
      }
    },
    //閉じるボタン
    close() {
      this.dialogIns = false;
      this.dialogInsEdit = false;
      this.ruleForm.year = "";
      this.insDecItemData = [];
      this.emptyInsDecData();
      this.emptyInsDecItemData();
    },
    handleClose(done) {
      this.$confirm(this.$t("general.close_comfirm"), {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonClass: "btn-custom-confirm",
        confirmButtonText: this.$t("general.confirm"),
        cancelButtonText: this.$t("general.cancel"),
        type: "warning",
      })
        .then((_) => {
          done();
          this.emptyInsDecItemData();
        })
        .catch((_) => { });
    },
    //給与所得者の保険料控除申告書編集/新規页面点击空白处的关闭处理
    handleDialogInsClose(done) {
      if (this.isInsDecValueEqual(this.tempForm, this.insForm) === false && Object.keys(this.tempForm) != "") {
        this.close_comfirm();
      } else {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning",
        })
          .then((_) => {
            done();
            this.ruleForm.year = "";
            this.insDecItemData = [];
            this.emptyInsDecData();
            this.tempForm = {};
          })
          .catch((_) => { });
      }
    },
    //保険料詳細キャンセル   
    cancelInsDetail() {
      this.dialogInsDetail = false;
      this.dialogInsDetailEdit = false;
      this.emptyInsDecItemData();
    },
    emptyInsDecItemData() {
      this.ruleForm.era = "",
        this.ruleForm.ins_type = "一般の生命保険料",
        this.ruleForm.ins_c_name = "",
        this.ruleForm.ins_type_detail = "",
        this.ruleForm.ins_date = "",
        this.ruleForm.ins_apply_name = "",
        this.ruleForm.ins_recevie_name = "",
        this.ruleForm.ins_relation = "",
        this.ruleForm.district = "",
        this.ruleForm.ins_payment = "",
        this.ruleForm.confirm = "",
        this.ruleForm.payYear = "",
        this.ruleForm.payMonth = "",
        this.ruleForm.payDay = ""
    },
    emptyInsDecData() {
      this.insForm = {
        life_insurance_a: 0,
        life_insurance_b: 0,
        care_insurance: 0,
        annuity_insurance_a: 0,
        annuity_insurance_b: 0,
        earthquake_insurance: 0,
        damage_insurance: 0,
        social_insurance: 0,
        ins_relation: 0,
        district: 0,
        c_deduction: 0
      }
    },
    //查询給与所得者の保険料控除合计额信息
    //返回值需要变为金额的显示方法，加逗号
    ListInsDeclarationByEid() {
      let postData = this.qs.stringify({
        eid: this.eid,
      });
      this.axios({
        method: "post",
        url: "/ListInsDeclarationByEid",
        data: postData,
      })
        .then((response) => {
          for (var i = 0; i < response.data.length; i++) {
            response.data[i].annuity_insurance_a = Number(response.data[i].annuity_insurance_a).toLocaleString();
            response.data[i].annuity_insurance_b = Number(response.data[i].annuity_insurance_b).toLocaleString();
            response.data[i].c_deduction = Number(response.data[i].c_deduction).toLocaleString();
            response.data[i].care_insurance = Number(response.data[i].care_insurance).toLocaleString();
            response.data[i].damage_insurance = Number(response.data[i].damage_insurance).toLocaleString();
            response.data[i].earthquake_insurance = Number(response.data[i].earthquake_insurance).toLocaleString();
            response.data[i].life_insurance_a = Number(response.data[i].life_insurance_a).toLocaleString();
            response.data[i].life_insurance_b = Number(response.data[i].life_insurance_b).toLocaleString();
            response.data[i].social_insurance = Number(response.data[i].social_insurance).toLocaleString();
          }
          this.insDecAmountData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //給与所得者の保険料控除申告ボタンを押下
    handleInsDeclaration(index, row) {
      this.dialogInsDeclaration = true;
      this.eid = row.id;
      this.name = row.name;
      this.employee_id = row.employee_id;
      this.ListInsDeclarationByEid();
    },
    //給与所得者の保険料控除申告書作成ボタンを押下
    insAdd() {
      this.dialogIns = true;
    },
    //給与所得者の保険料控除申告書詳細作成ボタンを押下     
    insFormAdd() {
      if (this.ruleForm.year != "") {
        this.dialogInsDetail = true;
      } else {
        this.$message({
          type: "warning",
          message: "年度を指定してください"
        });
      }

    },
    //点击table表格的排序箭头
    changeTableSort(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: this.sortName,
        sortOrder: this.sortOrder,
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      localStorage.setItem("sortNameSalaryMain", JSON.stringify(this.sortName));
      localStorage.setItem("sortOrderSalaryMain", JSON.stringify(this.sortOrder));
    },
    //点击分页页码
    handleSortChange(column) {
      this.sortName = column.prop;
      this.sortOrder = column.order;
      let postData = this.qs.stringify({
        sortName: JSON.parse(localStorage.getItem("sortNameSalaryMain")),
        sortOrder: JSON.parse(localStorage.getItem("sortOrderSalaryMain")),
        page: this.currentPage
      });
      this.axios({
        method: "post",
        url: "/changeTableSort",
        data: postData,
      })
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.axios
      .post("/pageEmpList")
      .then((response) => {
        this.tableData = response.data;
      })
      .catch((error) => { });
    this.axios
      .post("/rowsEmpList")
      .then((response) => {
        this.total = response.data;
      })
      .catch((error) => { });
  },
};
</script>
<style scoped>
.pages {
  margin: 0px;
  padding: 0px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/EndYearAdj/InsDeclaration.vue